import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { STANDARD_REPORTS } from '@reporting/meta/standard-reports.meta';
import { StandardReports } from '../../interfaces/standard-reports.interface';

@Component({
    templateUrl: './overview.view.html',
})
export class OverviewView implements OnInit {
    isLoading = false;
    standardReports: StandardReports[] = [];

    constructor(
        private auth: AuthService,
        private featureService: FeatureService
    ) {}

    async ngOnInit(): Promise<void> {
        this.getStandardReports();
    }

    async getStandardReports(): Promise<void> {
        for (const report of STANDARD_REPORTS) {
            if (report.showIfHasFeatureFlag && !(await this.featureService.has(report.showIfHasFeatureFlag))) {
                continue;
            }

            if (report.hideIfHasFeatureFlag && (await this.featureService.has(report.hideIfHasFeatureFlag))) {
                continue;
            }

            report.disabled = report.requiredModule ? this.companyHasModule(report.requiredModule) : false;

            this.standardReports.push(report);
        }
    }

    private companyHasModule(moduleName: string): boolean {
        return !(this.auth.company.modules.findIndex((module) => module.name === moduleName) > -1);
    }
}
